export default __webpack_public_path__ + "static/media/editicon.5f23c6dd.svg";